import customAxios from './customAxios';
import { PAYMENT_WITH_CARD, GET_PAYMENT_CARDS } from "./types";
import * as paymentService from '../common/services/payment.service';

//! Validate and refresh login tokens before calling this function 
export const makePaymentWithNewCard = (state, insuranceId, cashflowId, isStoreCard) => {
    const { shipmentDetails, auth} = state;

    const restoreData = {
      refreshToken: auth?.loginToken?.refresh_token,
     // insuranceId : insuranceId,
     // cashflowId  : cashflowId,
    }

    //const options = {headers: {'Web-Restore': JSON.stringify(restoreData)}};
    
    let body = paymentService.mapCardPaymentNoCardData(insuranceId, cashflowId, shipmentDetails, isStoreCard);

    body = {...body, webRestore: restoreData};

    const url  = `/syws-ins-vehicle/api/insVehicle/insContract/makePayment`;

    return customAxios.post(url, body);
}

export const makePaymentWitStoredCard = (state, insuranceId, cashflowId, isStoreCard, card) => {
  const {shipmentDetails} = state;
  
  const body = paymentService.mapCardPaymentWithCardData(card, insuranceId, cashflowId, shipmentDetails, isStoreCard);

  const url  = `/syws-ins-vehicle/api/insVehicle/insContract/makePayment`;

  return customAxios.post(url, body);
}

export const makeCashOnDeliveryPayment = (state, cashflowId) => {
  const {insOffers: {revisedOffer}, shipmentDetails} = state;
  
  const body = paymentService.mapCashOnDelivery(revisedOffer.insuranceId, cashflowId, shipmentDetails);

  const url  = `/syws-ins-vehicle/api/insVehicle/insContract/makePayment`;

  return customAxios.post(url, body);
}

export const payInstalmentCashOnDelivery = (policy, cashflowId, shipmentDetails) => {
  
  const body = paymentService.mapCashOnDelivery(policy?.insuranceId, cashflowId, shipmentDetails);

  const url  = `/syws-ins-vehicle/api/insVehicle/insContract/makePayment`;

  return customAxios.post(url, body);
}

export const getPaymentCards = () => async (dispatch, getState) => {

    const url  = `/syws-payment/card`;

    const options = { data: {}}; //this is an axios feature

    let res,
    payload = [];

    try{
        res = await customAxios.get(url, options);
    } catch (error) {
      console.log(error);
    }
    
    if(res?.data && !res?.data?.messageCode) {
        payload = res.data;
    }

   // console.log(res?.data)
        
    dispatch({type: GET_PAYMENT_CARDS, payload: payload});
  }

  export const deletePaymentCard = (cardId) => async (dispatch, getState) => {

    const url  = `/syws-payment/card`;

    const body = {cardId: cardId};

    const options = { data: {}}; //this is an axios feature

    let resDel, resCards,
    payload = [];

    try{
        resDel = await customAxios.post(url, body);
        resCards = await customAxios.get(url, options);
    } catch (error) {
      console.log(error);
    }
    
    if(resDel?.data && resDel?.data?.status === 0) {
      if(resCards?.data) {

        payload = resCards.data;

        dispatch({type: GET_PAYMENT_CARDS, payload: payload});
      }
    }

   // console.log(resDel?.data)
  }